(()=>{
  const RUNTIME_KEY='__aeeyaaAdhesiveSizeGuideRuntime';
  if(window[RUNTIME_KEY]){ window[RUNTIME_KEY].initAll(); return; }

  const SELECTOR='[data-aeeyaa-adhesive-size-helper-host]';

  function init(host){
    if(!host||host.dataset.aeeyaaAdhesiveInitialized==='true') return;

    const info=host.closest('.hdt-product-info__list')||document;
    const sourceTrigger=host.querySelector(':scope > [data-aeeyaa-adhesive-size-guide-trigger]');
    const dialog=host.querySelector('[data-aeeyaa-adhesive-size-dialog]');
    const close=host.querySelector('[data-aeeyaa-adhesive-size-close]');
    if(!sourceTrigger||!dialog) return;

    sourceTrigger.hidden=true;
    host.dataset.aeeyaaAdhesiveInitialized='true';
    let mountPending=false;
    let mountRetries=0;

    function getPicker(){ return info.querySelector('hdt-variant-picker'); }

    function getSizeField(picker){
      if(!picker) return null;
      return picker.querySelector('fieldset.is-style-size')||[...picker.querySelectorAll('fieldset')].find(fs=>{
        const legend=fs.querySelector('legend');
        return legend&&/^size\b/i.test(legend.textContent.trim());
      })||null;
    }

    function getForm(){
      const picker=getPicker();
      const formId=picker&&picker.getAttribute('form');
      return formId?document.forms[formId]:null;
    }

    function renameSizeLegend(sizeField){
      const legend=sizeField&&sizeField.querySelector('legend');
      if(!legend) return null;
      const label=legend.querySelector(':scope > span');
      if(label){
        const textNode=[...label.childNodes].find(n=>n.nodeType===Node.TEXT_NODE);
        if(textNode) textNode.nodeValue='Select Your Size';
        const update=label.querySelector('[update-value]');
        if(update) update.setAttribute('aria-hidden','true');
      }
      return legend;
    }

    function openDialog(){
      if(typeof dialog.showModal==='function'){
        if(!dialog.open) dialog.showModal();
      }else{
        dialog.setAttribute('open','');
      }
    }

    function closeDialog(){
      if(typeof dialog.close==='function'){
        if(dialog.open) dialog.close();
      }else{
        dialog.removeAttribute('open');
      }
    }

    function bindTrigger(trigger){
      if(!trigger||trigger.dataset.aeeyaaAdhesiveWired==='true') return;
      trigger.dataset.aeeyaaAdhesiveWired='true';
      trigger.addEventListener('click',openDialog);
    }

    function mountIntoPicker(){
      const picker=getPicker();
      const sizeField=getSizeField(picker);
      if(!picker||!sizeField) return false;

      sizeField.classList.add('aeeyaa-size-enabled');
      const legend=renameSizeLegend(sizeField);
      if(!legend) return false;

      [...legend.children].forEach(child=>{
        if(child.tagName==='BUTTON'||child.tagName==='WRAPP-OPEN-PSWP-BTN') child.style.display='none';
      });

      let mountedTrigger=legend.querySelector('[data-aeeyaa-adhesive-size-guide-trigger-mounted]');
      if(!mountedTrigger){
        mountedTrigger=sourceTrigger.cloneNode(true);
        mountedTrigger.hidden=false;
        mountedTrigger.style.display='';
        mountedTrigger.removeAttribute('data-aeeyaa-adhesive-size-guide-trigger');
        mountedTrigger.setAttribute('data-aeeyaa-adhesive-size-guide-trigger-mounted','');
        legend.appendChild(mountedTrigger);
      }
      bindTrigger(mountedTrigger);
      mountRetries=0;
      return true;
    }

    function scheduleMount(){
      if(mountPending) return;
      mountPending=true;
      requestAnimationFrame(()=>{
        mountPending=false;
        if(!mountIntoPicker()&&mountRetries<8){
          mountRetries+=1;
          setTimeout(scheduleMount,60);
        }
      });
    }

    if(close) close.addEventListener('click',closeDialog);
    dialog.addEventListener('click',event=>{ if(event.target===dialog) closeDialog(); });

    const form=getForm();
    if(form) form.addEventListener('variant:change',scheduleMount);
    scheduleMount();
  }

  function initAll(root=document){
    const candidates=[];
    if(root.matches&&root.matches(SELECTOR)) candidates.push(root);
    if(root.querySelectorAll) candidates.push(...root.querySelectorAll(SELECTOR));
    candidates.forEach(init);
  }

  const runtime={initAll};
  window[RUNTIME_KEY]=runtime;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(),{once:true});
  else initAll();
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
